import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Cheese = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "-.125em",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M0 288v160a32 32 0 0032 32h448a32 32 0 0032-32V288zM299.83 32a32 32 0 00-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z",
    key: "k0"
  }));
});
Cheese.displayName = 'Cheese';
export var CheeseDimensions = {
  height: undefined,
  width: undefined
};